import makeStyles from '@material-ui/styles/makeStyles'

export const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: '3rem',
    maxWidth: 1200,
  },
}))
